import { reactive } from 'vue';
const AppState = reactive({
    locationId: '',
    eventId: '',
    location: '',
    timezone: 'UTC',
    locale: '',
    receivedData: {},
    viewActivityLog: false,
    viewAdditionalDetails: false,
    viewUserInfo: false,
    showEditAppointmentModal: false,
    editAppointmentData: {},
    appointmentDetail: undefined,
    calendarDetail: undefined,
    contactDetails: undefined,
    userDetails: undefined,
    appointmentOwnerDetails: undefined,
    guestsDetails: [],
    appointmentsRef: [],
    loggedInUserId: '',
});
export const setInitialValues = (data) => {
    var _a;
    AppState.eventId = data.eventId;
    AppState.location = data.location;
    AppState.timezone = data.timeZone;
    AppState.receivedData = data;
    AppState.loggedInUserId = (_a = data === null || data === void 0 ? void 0 : data.userId) !== null && _a !== void 0 ? _a : '';
};
export const resetAppState = () => {
    AppState.locationId = '';
    AppState.eventId = '';
    AppState.location = '';
    AppState.timezone = 'UTC';
    AppState.locale = '';
    AppState.receivedData = {};
    AppState.viewActivityLog = false;
    AppState.viewAdditionalDetails = false;
    AppState.viewUserInfo = false;
    AppState.showEditAppointmentModal = false;
    AppState.editAppointmentData = {};
    AppState.appointmentDetail = null;
    AppState.calendarDetail = null;
    AppState.contactDetails = null;
    AppState.userDetails = null;
    AppState.appointmentOwnerDetails = null;
    AppState.guestsDetails = [];
    AppState.appointmentsRef = [];
    AppState.loggedInUserId = '';
};
export const setEventId = (id) => {
    AppState.eventId = id;
};
export const setLocationId = (id) => {
    AppState.locationId = id;
};
export const setViewActivityLog = (value) => {
    AppState.viewActivityLog = value;
};
export const setViewAdditionalDetails = (value) => {
    AppState.viewAdditionalDetails = value;
};
export const openEditAppointmentModal = eventType => {
    const editAppointmentData = AppState.receivedData;
    const isBlockSlot = eventType === 'event';
    editAppointmentData.reschedule = 'All';
    editAppointmentData.isNewBlockSlot = isBlockSlot ? true : false;
    editAppointmentData.isNewEvent = isBlockSlot ? false : true;
    editAppointmentData.locationId = AppState.locationId;
    editAppointmentData.calendars = AppState.receivedData.calendars;
    editAppointmentData.groups = AppState.receivedData.groups;
    editAppointmentData.users = AppState.receivedData.users;
    if (editAppointmentData.appointmentIds) {
        editAppointmentData.appointmentIds = Array.from(editAppointmentData === null || editAppointmentData === void 0 ? void 0 : editAppointmentData.appointmentIds);
    }
    AppState.editAppointmentData = editAppointmentData;
    AppState.showEditAppointmentModal = !AppState.showEditAppointmentModal;
};
export default AppState;
